import { Routes } from '@angular/router';

import {LegalComponent} from './legal.component';


export const legalRoute: Routes = [
  {
    path: 'legal',
    component: LegalComponent,
    data: {
        pageTitle: 'cadensApp.legal.home.title'
    }
  }
];




// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/legal/legal.route.ts